var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-shrink-0 rounded-full flex items-center justify-center font-bold font-sans",class:[_vm.sizeClass, _vm.muted ? 'bg-gray-100 text-gray-400' : 'bg-primary-100 text-primary-700']},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }